<template>
  <div>
    <div class="service-container" style="margin-top: 8px;">
      <img class="service-main-img" src="@/assets/img/技术支持.png" alt="技术支持主图" loading="eager" />
    </div>
    <div class="calculator-container">
      <div class="header">
        <h1>多肽计算器</h1>
        <p class="subtitle">多肽计算器(专业版)</p>
      </div>

      <div class="calculator-content">
        <div class="input-section">
          <div class="input-group">
            <label>序列（可输入氨基酸单字母或多字母，单字母为大写字母）</label>
            <el-input
              v-model="formData.sequence"
              type="textarea"
              :rows="3"
              placeholder="例如：ACDEFG 或 Ala-Cys-Asp-Glu-Phe-Gly"
              class="sequence-input"
            ></el-input>
          </div>

          <el-button
            type="primary"
            @click="calculate"
            :loading="loading"
            class="calculate-btn"
          >
            计算
          </el-button>

          <div class="disulfide-section">
            <h3>二硫键修饰</h3>
            <el-input
              v-model="formData.disulfide"
              placeholder="请输入二硫键修饰信息"
              clearable
            ></el-input>
          </div>

          <div class="cycle-section">
            <h3>成环类型</h3>
            <el-select
              v-model="formData.cycleType"
              placeholder="请选择成环类型"
              class="cycle-select"
            >
              <el-option label="未成环" value="none"></el-option>
              <el-option label="主链成环" value="main"></el-option>
              <el-option label="侧链成环" value="side"></el-option>
              <el-option label="主（N端）侧（C端）成环" value="mainN_sideC"></el-option>
              <el-option label="侧（N端）主（C端）成环" value="sideN_mainC"></el-option>
              <el-option label="硫醚成环" value="sulfide"></el-option>
            </el-select>
          </div>

          <div v-if="warning" class="warning-section">
            <el-alert :title="warning" type="warning" show-icon></el-alert>
          </div>
        </div>

        <div class="result-section" v-if="result">
          <h3>计算结果</h3>
            <div class="result-content">
            <div class="result-item">
              <span class="result-label">单字符:</span>
              <span class="result-value">{{ result.single || 'N/A' }}{{ result.attachs && result.attachs.length > 0 ? '(' + result.attachs[0] + ')' : '' }}</span>
            </div>
            <div class="result-item">
              <span class="result-label">多字符:</span>
              <span class="result-value">{{ result.full || 'N/A' }}{{ result.attachs && result.attachs.length > 0 ? '(' + result.attachs[0] + ')' : '' }}</span>
            </div>
            <div class="result-item">
              <span class="result-label">氨基酸个数:</span>
              <span class="result-value">{{ result.aminoCount || 'N/A' }}</span>
            </div>
            <div class="result-item">
              <span class="result-label">分子式:</span>
              <span class="result-value">{{ result.formula || 'N/A' }}</span>
            </div>
            <div class="result-item">
              <span class="result-label">平均分子量(MW):</span>
              <span class="result-value">{{ result.mw || 'N/A' }}g/mol</span>
            </div>
            <div class="result-item">
              <span class="result-label">精确分子量(Exact Mass):</span>
              <span class="result-value">{{ result.em || 'N/A' }}</span>
            </div>
            <div class="result-item">
              <span class="result-label">等电点(PI):</span>
              <span class="result-value">{{ result.pi || 'N/A' }}</span>
            </div>
            <div class="result-item">
              <span class="result-label">pH=7.0时的净电荷数:</span>
              <span class="result-value">{{ result.pi7 !== null && result.pi7 !== undefined ? result.pi7.toFixed(2) : 'N/A' }}</span>
            </div>
            <div class="result-item">
              <span class="result-label">平均亲水性:</span>
              <span class="result-value">{{ result.hydrophilyResult || 'N/A' }}</span>
            </div>
            <div class="result-item">
              <span class="result-label">N含量:</span>
              <span class="result-value">{{ result.nPercent || 'N/A' }}%</span>
            </div>
            <div class="result-item">
              <span class="result-label">溶解性1:</span>
              <span class="result-value">{{ result.solubilityResult || 'N/A' }} ( 备注：由于溶解性不仅与氨基酸的序列有关，也和产品所带的反离子有关，若溶解性遇到问题，可咨询我们的技术人员，我们可提供溶解方法或进行序列修饰以提高溶解性。)</span>
            </div>
            <div class="result-item">
              <span class="result-label">溶解性2:</span>
              <span class="result-value">{{ result.solubilityResult2 || 'N/A' }}</span>
            </div>

            <div class="result-table-container" v-if="result.aminoDetails">
              <h4>氨基酸</h4>
              <div class="result-table">
                <table>
                  <thead>
                    <tr>
                      <th>氨基酸</th>
                      <th>个数</th>
                      <th>残基分子量</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(detail, key) in result.aminoDetails" :key="key">
                      <td>{{ detail.name }}({{ key }})</td>
                      <td>{{ detail.count }}</td>
                      <td>{{ detail.residueWeight }}</td>
                    </tr>
                    <tr class="total-row">
                      <td>氨基酸总数</td>
                      <td>{{ result.aminoCount || 'N/A' }}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="result-table-container" v-if="result.piAminos">
              <h4>(PI相关氨基酸个数)</h4>
              <div class="result-table">
                <table>
                  <thead>
                    <tr>
                      <th>氨基酸</th>
                      <th>个数</th>
                      <th>残基分子量</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(detail, key) in result.piAminos" :key="key">
                      <td>{{ detail.name }}({{ key }})</td>
                      <td>{{ detail.count }}</td>
                      <td>{{ detail.residueWeight }}</td>
                    </tr>
                    <tr class="total-row">
                      <td>氨基酸总数</td>
                      <td>{{ result.piAminoCount || 'N/A' }}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="result-table-container" v-if="result">
              <h4>净电荷数随 pH 值变化曲线</h4>
              <div class="chart-container">
                <div v-if="result.y && result.y.length > 0" ref="phChart" style="width: 100%; height: 400px;"></div>
                <div v-else style="padding: 20px; text-align: center; color: #909399;">
                  暂无图表数据
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-dialog title="多肽计算器软件说明" :visible.sync="showHelp" :width="dialogWidth">
        <div class="help-content">
          <ol>
            <li>序列输入可以单字母输入，比如序列：Ala-Cys-Asp-Glu-Phe-Gly，也可以输入ACDEFG。对于特殊氨基酸，可使用其缩写，但需要用-进行间隔，比如序列：Ala-Cys-Asp-Glu-Phe-Gly-Ser(PO3H)，也可以输入ACDEFG-pS。对于D型氨基酸，比如D型Ala，可以输入DAla。</li>
            <li>关于特殊氨基酸的标示方法，点击此处</li>
            <li>对于酰胺键成环序列，可以在成环处加入Cyclo。比如序列Glu-Cys-Asp-Glu-Phe-Lys首尾成环，可以输入Cyclo(Glu-Cys-Asp-Glu-Phe-Lys)或Cyclo(ECDEFK)，并在下面选择"主链成环"。</li>
            <li>对于硫醚键，比如卡贝缩宫素：Butyryl-Tyr(Me)-Ile-Gln-Asn-Cys-Pro-Leu-Gly-NH2 (Sulfide bond between Butyryl-4-yl and Cys),可以输入Cyclo(Butyryl-Tyr(Me)-Ile-Gln-Asn-Cys)-Pro-Leu-Gly-NH2，或输入Cyclo(Butyryl-Tyr(Me)-IQNC)PLG-NH2并在下面选择"硫醚成环"。</li>
            <li>为了更好的判断序列，建议特殊序列采用三字母序列进行输入。</li>
            <li>对于输出的溶解性：溶解性1：可以指导你进行溶解性实验；溶解性2：只判断是否可溶于水，由于采用更严格的判断条件，部分水溶性样品的判断结果是"水溶性不确定"。</li>
            <li>更多序列举例，点击此处</li>
          </ol>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showHelp = false">确定</el-button>
        </span>
      </el-dialog>

      <div class="help-button">
        <el-button @click="showHelp = true" type="info" icon="el-icon-info">
          多肽计算器软件说明
        </el-button>
      </div>
    </div>
    <!-- 底部信息 -->
    <div class="tk-footer">
      <div>电话：15002819872&nbsp; 邮箱：15002819872@163.com&nbsp; 地址：江西省赣州市章贡区长征大道12号</div>
      <div>备案号: <a href="https://beian.miit.gov.cn/#/Integrated/index">赣ICP备2026004521号-1</a></div>
    </div>
  </div>
</template>

<script>
import { calculatePeptide } from '@/api/peptide';
import * as echarts from 'echarts';

export default {
  name: 'PeptideCalculator',
  data() {
    return {
      loading: false,
      showHelp: false,
      warning: '',
      result: null,
      dialogWidth: '60%',
      formData: {
        sequence: '',
        disulfide: '',
        cycleType: 'none',
        chainA: 'none',
        chainB: 'none'
      },
      cycleTypeMap: {
        'none': -1,
        'main': 0,
        'side': 1,
        'mainN_sideC': 2,
        'sideN_mainC': 3,
        'sulfide': 4
      }
    };
  },
  mounted() {
    this.updateDialogWidth();
    window.addEventListener('resize', this.updateDialogWidth);
  },

  methods: {
    updateDialogWidth() {
      this.dialogWidth = window.innerWidth < 768 ? '95%' : '60%';
    },
    mapResultData(data) {
      if (!data) {
        console.log('mapResultData: data is null or undefined');
        return null;
      }

      console.log('mapResultData input:', data);
      console.log('Keys in data:', Object.keys(data));
      console.log('data.single:', data.single);
      console.log('data.full:', data.full);
      console.log('data.checkSubject:', data.checkSubject);
      console.log('data.finalSubject:', data.finalSubject);

      // 计算分子式（从 elementAminos 中聚合）
      let elements = { c: 0, h: 0, n: 0, o: 0, s: 0, cl: 0, f: 0, p: 0 };
      const elementAminos = data.elementAminos || {};
      console.log('elementAminos:', elementAminos);

      Object.values(elementAminos).forEach(amino => {
        const std = amino.aminoStandard;
        const count = amino.count || 1;
        if (std) {
          elements.c += (std.c || 0) * count;
          elements.h += (std.h || 0) * count;
          elements.n += (std.n || 0) * count;
          elements.o += (std.o || 0) * count;
          elements.s += (std.s || 0) * count;
          elements.cl += (std.cl || 0) * count;
          elements.f += (std.f || 0) * count;
          elements.p += (std.p || 0) * count;
        }
      });

      console.log('Elements:', elements);

      // 添加 N 端和 C 端的原子
      // N端有 H-，加一个 H
      if (data.ntermCount && data.ntermCount > 0) {
        elements.h += 1;
      }
      // C端有 OH，加一个 O 和 H
      if (data.ctermCount && data.ctermCount > 0) {
        elements.o += 1;
        elements.h += 1;
      }

      // 生成分子式字符串
      let formula = '';
      if (elements.c > 0) formula += `C${elements.c}`;
      if (elements.h > 0) formula += `H${elements.h}`;
      if (elements.n > 0) formula += `N${elements.n}`;
      if (elements.o > 0) formula += `O${elements.o}`;
      if (elements.s > 0) formula += `S${elements.s}`;
      if (elements.cl > 0) formula += `Cl${elements.cl}`;
      if (elements.f > 0) formula += `F${elements.f}`;
      if (elements.p > 0) formula += `P${elements.p}`;

      // 计算分子量（平均分子量）
      const atomicWeights = {
        c: 12.01, h: 1.008, n: 14.01, o: 16.00, s: 32.07, cl: 35.45, f: 19.00, p: 30.97
      };
      let mw = 0;
      Object.keys(elements).forEach(key => {
        mw += elements[key] * (atomicWeights[key] || 0);
      });

      // 计算精确分子量
      const exactWeights = {
        c: 12.0000, h: 1.007825, n: 14.003074, o: 15.994915, s: 31.972071,
        cl: 34.968853, f: 18.998403, p: 30.973762
      };
      let em = 0;
      Object.keys(elements).forEach(key => {
        em += elements[key] * (exactWeights[key] || 0);
      });

      // 计算等电点 PI（从 y 数组中找到第一个接近0.5的点）
      let pi = null;
      if (data.y && data.y.length > 0) {
        // y 数组是 [pH, netCharge]，找到净电荷接近 0 的 pH 值
        for (let i = 0; i < data.y.length; i++) {
          if (Math.abs(data.y[i][1]) < 0.01) {
            pi = data.y[i][0];
            break;
          }
        }
      }
      console.log('PI:', pi);

      // 计算亲水性
      let hydrophilyResult = data.hydrophilyResult;
      const hydrophilyCount = data.hydrophilyResult

      console.log('hydrophilyResult:', hydrophilyResult);

      // 溶解性判断（基于 hydrophily）
      let solubilityResult = '';
      let solubilityResult2 = '';
      if (hydrophilyCount !== undefined && hydrophilyCount !== null) {
        if (hydrophilyCount >= 1) {
          solubilityResult = '水溶';
          solubilityResult2 = '不确定水可溶';
        } else if (hydrophilyCount >= 0) {
          solubilityResult = '水溶性较好';
          solubilityResult2 = '水溶性';
        } else if (hydrophilyCount >= -1) {
          solubilityResult = '水溶性一般，可用DMSO等有机溶剂辅助溶解';
          solubilityResult2 = '水溶性不确定';
        } else {
          solubilityResult = '水溶性较差，建议使用DMSO或其他有机溶剂';
          solubilityResult2 = '不溶于水';
        }
      }
      console.log('solubilityResult:', solubilityResult);

      const mappedResult = {
        // 直接使用后端返回的数据，不使用 ...data 展开避免覆盖
        single: data.single || 'N/A',
        full: data.full || 'N/A',
        aminoCount: data.aminoCount || 'N/A',
        formula: data.formula || 'N/A',
        mw: data.mw !== undefined ? (typeof data.mw === 'number' ? data.mw.toFixed(2) : data.mw) : 'N/A',
        em: data.em !== undefined ? (typeof data.em === 'number' ? data.em.toFixed(4) : data.em) : 'N/A',
        pi: data.pi !== undefined ? (typeof data.pi === 'number' ? data.pi.toFixed(2) : data.pi) : 'N/A',
        pi7: data.pi7 !== undefined ? data.pi7 : null,
        hydrophilyResult: hydrophilyResult || 'N/A',
        nPercent: data.nPercent !== undefined ? (typeof data.nPercent === 'number' ? data.nPercent.toFixed(2) : data.nPercent) : 'N/A',
        solubilityResult: data.solubilityResult || solubilityResult || 'N/A',
        solubilityResult2: data.solubilityResult2 || solubilityResult2 || 'N/A',
        aminoDetails: data.aminoDetails || null,
        piAminos: data.piAminos || null,
        piAminoCount: data.piAminoCount || 'N/A',
        y: data.y || null
      };

      console.log('Final mapped result.single:', mappedResult.single);
      console.log('Final mapped result.full:', mappedResult.full);
      console.log('Final mapped result.aminoCount:', mappedResult.aminoCount);
      console.log('Final mapped result:', mappedResult);
      return mappedResult;
    },
    async calculate() {
      if (!this.formData.sequence.trim()) {
        this.$message.warning('请输入多肽序列');
        return;
      }

      this.loading = true;
      this.warning = '';
      this.result = null;

      try {
        const params = {
          amino: this.formData.sequence.replace(/\s+/g, '').trim()
        };

        if (this.formData.disulfide.trim()) {
          params.s2 = this.formData.disulfide.trim();
        }

        params.cycloType = this.cycleTypeMap[this.formData.cycleType];

        if (this.formData.disulfide.trim()) {
          params.cycloTypeA = this.cycleTypeMap[this.formData.chainA];
          params.cycloTypeB = this.cycleTypeMap[this.formData.chainB];
        }

        const response = await calculatePeptide(params);
        console.log('API Response:', response);
        console.log('Response data:', response.data);
        console.log('Response data data:', response.data.data.data);

        // 尝试不同的数据路径
        let backendData = null;
        if (response.data && response.data.data.data) {
          backendData = response.data.data.data;
        } else if (response.data) {
          backendData = response.data;
        }

        console.log('Backend data:', backendData);

        // 映射数据
        this.result = this.mapResultData(backendData);
        console.log('Mapped result:', this.result);
        console.log('y array:', this.result.y);

        // 初始化图表
        this.$nextTick(() => {
          console.log('NextTick callback, calling initChart');
          this.initChart();
        });
      } catch (error) {
        console.error('计算失败:', error);
        if (error.response && error.response.data && error.response.data.warning) {
          this.warning = error.response.data.warning;
        } else {
          this.$message.error('计算失败，请检查输入序列');
        }
      } finally {
        this.loading = false;
      }
    },
    initChart() {
      console.log('initChart called');
      console.log('result:', this.result);
      console.log('result.y:', this.result ? this.result.y : 'result is null');

      if (!this.result || !this.result.y || this.result.y.length === 0) {
        console.log('No y data available, skipping chart');
        return;
      }

      const chartDom = this.$refs.phChart;
      if (!chartDom) {
        console.log('Chart DOM element not found');
        return;
      }

      console.log('Initializing chart with data length:', this.result.y.length);

      // 如果图表已存在，先销毁
      if (this.phChart) {
        console.log('Disposing existing chart');
        this.phChart.dispose();
      }

      console.log('Creating new ECharts instance');
      this.phChart = echarts.init(chartDom);

      // 准备数据
      const phValues = this.result.y.map(item => item[0]);
      const chargeValues = this.result.y.map(item => item[1]);

      const option = {
        title: {
          text: '净电荷数 - pH 曲线',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          formatter: function(params) {
            const param = params[0];
            return `pH: ${param.axisValue}<br/>净电荷数: ${param.value}`;
          }
        },
        xAxis: {
          type: 'category',
          name: 'pH 值',
          nameLocation: 'middle',
          nameGap: 30,
          data: phValues,
          axisLabel: {
            formatter: function(value) {
              return typeof value === 'number' ? value.toFixed(2) : value;
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '净电荷数',
          axisLabel: {
            formatter: function(value) {
              return typeof value === 'number' ? value.toFixed(2) : value;
            }
          }
        },
        series: [
          {
            name: '净电荷数',
            type: 'line',
            data: chargeValues,
            smooth: true,
            symbol: 'circle',
            symbolSize: 4,
            lineStyle: {
              width: 2,
              color: '#409EFF'
            },
            itemStyle: {
              color: '#409EFF'
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(64, 158, 255, 0.3)' },
                  { offset: 1, color: 'rgba(64, 158, 255, 0.05)' }
                ]
              }
            },
            markLine: {
              data: [{ type: 'average', name: '平均值' }],
              lineStyle: {
                color: '#F56C6C',
                type: 'dashed'
              }
            }
          }
        ],
        grid: {
          left: '10%',
          right: '5%',
          bottom: '15%',
          top: '15%',
          containLabel: true
        }
      };

      this.phChart.setOption(option);

      // 响应式调整
      window.addEventListener('resize', this.handleChartResize);
    },
    handleChartResize() {
      if (this.phChart) {
        this.phChart.resize();
      }
    }
  },
  beforeDestroy() {
    // 组件销毁时移除事件监听和销毁图表
    window.removeEventListener('resize', this.handleChartResize);
    if (this.phChart) {
      this.phChart.dispose();
    }
  }
};
</script>

<style scoped>
.service-container {
  width: 100%;
  overflow: hidden;
}

.service-main-img {
  width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: cover;
  display: block;
}

.calculator-container {
  max-width: 1200px;
  margin: 20px auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.header {
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 2px solid #409EFF;
  padding-bottom: 20px;
}

.header h1 {
  color: #303133;
  margin: 0 0 10px 0;
  font-size: 28px;
}

.subtitle {
  color: #909399;
  margin: 0;
  font-size: 14px;
}
.tk-footer {
  background: #2f2f2f;
  color: #fff;
  text-align: center;
  padding: 30px 0 10px 0;
  margin-top: 40px;
}
.tk-footer div {
  margin: 5px 0;
  font-size: 14px;
}
.tk-footer a {
  color: #fff;
  text-decoration: none;
}
.calculator-content {
  display: flex;
  gap: 30px;
}

.input-section {
  flex: 1;
}

.result-section {
  flex: 1;
  background: #f5f7fa;
  padding: 20px;
  border-radius: 8px;
}

.input-group {
  margin-bottom: 20px;
}

.input-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #606266;
}

.sequence-input {
  margin-bottom: 15px;
}

.calculate-btn {
  width: 100%;
  margin-bottom: 30px;
  padding: 12px;
  font-size: 16px;
}

.disulfide-section,
.cycle-section,
.chain-section {
  margin-bottom: 20px;
  padding: 15px;
  background: #f9fafc;
  border-radius: 6px;
}

.disulfide-section h3,
.cycle-section h3,
.chain-section h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #303133;
}

.cycle-select {
  width: 100%;
}

.chain-selectors {
  display: flex;
  gap: 20px;
}

.chain-group {
  flex: 1;
}

.chain-group label {
  display: block;
  margin-bottom: 8px;
  color: #606266;
}

.chain-group .el-select {
  width: 100%;
}

.warning-section {
  margin-top: 20px;
}

.result-section h3 {
  margin: 0 0 20px 0;
  color: #303133;
  border-bottom: 2px solid #409EFF;
  padding-bottom: 10px;
  font-size: 18px;
}

.result-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.result-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 8px;
  transition: all 0.3s;
}

.result-item:hover {
  background: #e6f1fc;
  transform: translateX(3px);
}

.result-label {
  font-weight: 500;
  color: #606266;
  flex-shrink: 0;
  min-width: 200px;
}

.result-value {
  color: #303133;
  font-weight: 600;
  text-align: right;
  word-break: break-all;
  flex: 1;
}

.result-table-container {
  margin-top: 20px;
}

.result-table-container h4 {
  margin: 0 0 12px 0;
  color: #409EFF;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px dashed #dcdfe6;
  padding-bottom: 8px;
}

.result-table {
  overflow-x: auto;
}

.result-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.result-table th {
  background: #409EFF;
  color: #fff;
  padding: 10px;
  text-align: left;
  font-weight: 600;
}

.result-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #e4e7ed;
}

.result-table tbody tr:nth-child(even) {
  background: #f9fafc;
}

.result-table tbody tr:hover {
  background: #e6f1fc;
}

.total-row {
  background: #409EFF !important;
  color: #fff;
  font-weight: 600;
}

.total-row td {
  border-bottom: none;
}

.chart-container {
  padding: 10px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.help-content ol {
  padding-left: 20px;
}

.help-content li {
  margin-bottom: 12px;
  line-height: 1.8;
  color: #606266;
}

.help-button {
  text-align: center;
  margin-top: 30px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .service-main-img {
    max-height: 250px;
    object-fit: contain;
  }
  .tk-footer {
    padding: 20px 10px 10px 10px;
    margin-top: 20px;
    font-size: 12px;
    line-height: 1.6;
  }
  .tk-footer div {
    word-break: break-all;
    padding: 0 5px;
  }
  .calculator-container {
    margin: 10px;
    padding: 15px;
  }

  .header h1 {
    font-size: 22px;
  }

  .subtitle {
    font-size: 12px;
  }

  .calculator-content {
    flex-direction: column;
    gap: 20px;
  }

  .result-section {
    padding: 15px;
  }

  .input-group label {
    font-size: 14px;
  }

  .disulfide-section h3,
  .cycle-section h3,
  .chain-section h3 {
    font-size: 14px;
  }

  .chain-selectors {
    flex-direction: column;
    gap: 15px;
  }

  .result-item {
    flex-direction: column;
    gap: 5px;
  }

  .result-label {
    font-size: 14px;
  }

  .result-value {
    font-size: 15px;
    word-break: break-word;
  }

  .help-content li {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .service-main-img {
    max-height: 180px;
  }

  .header h1 {
    font-size: 18px;
  }

  .calculator-container {
    margin: 5px;
    padding: 10px;
  }

  .header {
    margin-bottom: 20px;
    padding-bottom: 15px;
  }

  .input-group label {
    font-size: 13px;
  }

  .disulfide-section,
  .cycle-section,
  .chain-section {
    padding: 12px;
  }

  .help-content li {
    font-size: 12px;
  }
}
</style>
